<template>
  <div class="code_mirror_wrapper" :class="{ code_mirror_wrapper_big: false}">
    <codemirror class="CodeMirror" v-model="code" :options="cmOptions" @input="onCmCodeChange"></codemirror>
  </div>
</template>

<script>
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/htmlmixed/htmlmixed.js";
import "codemirror/theme/dracula.css";
export default {
  props: ["startingCode", "big"],
  data() {
    return {
      code: this.startingCode,
      cmOptions: {
        tabSize: 4,
        mode: "text/html",
        theme: "dracula",
        lineNumbers: true,
        line: true
      }
    };
  },
  methods: {
    onCmCodeChange(newCode) {
      this.code = newCode;
      this.$emit('codeChanged', newCode);
    },
    changeCode(newCode){
      this.code = newCode;
    }
  },
  components: {
    codemirror
  }
};
</script>

<style scoped>
.code_mirror_wrapper {
  width: 200px;
  height: 300px;
}
.code_mirror_wrapper_big{
  height: 300px;
}
</style>
